


<h1>View Customer </h1>
<div class="container">
    <h1>Install Bootstrap 4 in Angular 9 - ItSolutionStuff.com</h1>
  
    <div class="card">
      <div class="card-header">
        Featured
      </div>
      <div class="card-body">
        <h5 class="card-title">Special title treatment</h5>
        <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
        <a href="#" class="btn btn-primary">Go somewhere</a>
      </div>
    </div>
  </div>


  <div class="container">
    <div class="section-header">
        <h2 class="section-title text-center wow fadeInDown">Awesome Features</h2>
        <p class="text-center wow fadeInDown">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut <br> et dolore magna aliqua. Ut enim ad minim veniam</p>
    </div>
  </div> 